import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode is intentionally omitted — it double-invokes effects
// in dev which conflicts with react-leaflet 4 (throws "Map container is
// already initialized" on mount). Production builds don't use StrictMode
// anyway, so this only affects the dev experience.
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// Cross-fade the boot splash out once React has painted the first frame.
// Extend fade to 700ms + gentle scale-up + blur so the splash recedes into
// the hero image rather than hard-cutting.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const el = document.getElementById("boot-splash");
    const bar = document.getElementById("boot-splash-bar");
    if (window.__adnBootSplashInterval) clearInterval(window.__adnBootSplashInterval);
    if (bar) bar.style.width = "100%";
    if (el) {
      setTimeout(() => {
        el.style.opacity = "0";
        el.style.transform = "scale(1.04)";
        el.style.filter = "blur(6px)";
        el.style.pointerEvents = "none";
        setTimeout(() => el.remove(), 750);
      }, 320);
    }
  });
});

// Register the PWA service worker (production build only — dev CRA server does not serve SW correctly)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // Silent — SW is a progressive enhancement
        console.warn("SW registration failed:", err);
      });
  });
}
